import React, { Component } from "react";
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import "../../../View.css";
import "../../../Grid.css";
import "../../../Form.css";
import "../../../App.css";
import SearchView from "../../../widgets/SearchView";
import PivotalProgrammeSearchForm from './PivotalProgrammeSearchForm';
import { ViewContainer } from "./../../../View.jsx";
import CardLayout from '../../../widgets/Card';
import ViewUtils from '../../../ViewUtils';

const utils = new ViewUtils();

const headCells = [
    { id: "Description", numeric: false, disablePadding: true, label: "PivotalProgramme Description" }
]

const toolbarConfig = {
    items: [
        {
            type: "buttonGroup",
            buttons: [
                { id: 'info', label: '', tooltip: 'Select Pivotal Programme from the table and click save to add', icon: 'InfoIcon' }
            ]
        }
    ]
}

class PivotalProgrammeSearch extends Component {
    constructor(props) {
        super(props);

        this.searchParameters = !utils.isNull(this.props.WSPATRID) ?
            //For search of providers that can be linked to a particular entity
            [
                { Name: "WSPATRID", Value: this.props.WSPATRID },
                { Name: "PivotalProgrammeDescription", Value: "" }
            ]
            :
            //For search on the provider search screen
            [
                { Name: "PivotalProgrammeDescription", Value: "" }
            ]

        let model = !utils.isNull(this.props.WSPATRID) ?
            {
                PivotalProgrammeDescription: "",
                WSPATRID: this.props.WSPATRID
            }
            :
            {
                PivotalProgrammeDescription: ""
            }

        this.state = {
            model: model,
            keyUpSwitch: false,
            selectedPivotalProgramme: null,
            linkDialogOpen: false
        }
    }

    onkeyup(e) {
        if (e.charCode == 13) {
            this.setState({ keyUpSwitch: !this.state.keyUpSwitch })
        }
    }

    render() {
        return (
            <ViewContainer mode={this.props.mode} title={this.props.showTitle === true || utils.isNull(this.props.showTitle) ? 'PivotalProgramme Occupations' : null}>
                <SearchView
                    config={toolbarConfig}
                    mode={this.props.mode}
                    headCells={headCells}
                    dataUrl={!utils.isNull(this.props.dataUrl) ? this.props.dataUrl : "api/indicium/PivotalProgrammeOccupation/search"}
                    onLookupValueChange={this.props.onLookupValueChange}
                    descriptionProp="Description"
                    model={this.state.model}
                    searchParameters={this.searchParameters}
                    keyUpSwitch={this.state.keyUpSwitch}
                >
                    <PivotalProgrammeSearchForm onKeyUp={(e) => { this.onkeyup(e) }} model={this.state.model} />
                </SearchView>
            </ViewContainer>
        )
    }
}

export default withRouter(
    connect()(PivotalProgrammeSearch)
);